export const DocumentDownlaoder = (name: any, data: any, showPopup: (e: any, k: any) => void) => {
    try {
        const preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
                        "xmlns:w='urn:schemas-microsoft-com:office:word' " +
                        "xmlns='http://www.w3.org/TR/REC-html40'>" +
                        "<head><meta charset='utf-8'></head><body>";
        const postHtml = "</body></html>";
        const html = preHtml + data + postHtml;
        const blob = new Blob(['\ufeff', html], {type: 'application/msword'});
        const downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);
        const url = URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = name + ".doc";
        downloadLink.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(downloadLink);
        showPopup("Sikeresen másoltad a dokumentum adatait!", "success");
    } catch (err) {
        console.error(err);
        showPopup("Nem sikerült másolni a dokumentum adatait.", "fail");
    }
};

export const copyDocumentData = (htmlString: string, showPopup: (e: any, k: any) => void) => {
    try {
      const el = document.createElement('div');
      el.innerHTML = htmlString;
      document.body.appendChild(el);
      const range = document.createRange();
      range.selectNodeContents(el);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);
      document.execCommand('copy');
      document.body.removeChild(el);
      selection?.removeAllRanges();
      showPopup("Sikeresen másoltad a dokumentum adatait!", "success");
    } catch (err) {
      console.error(err);
      showPopup("Nem sikerült másolni a dokumentum adatait.", "fail");
    }
  }